module.exports = __webpack_public_path__ + "fonts/HalisR-S-Medium.2230ac91.otf";